import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/catalyst/button';

export const DirectoryQuickAccessButton = () => {
  const navigate = useNavigate();

  return (
    <Button outline onClick={() => navigate('/provider-directory')}>
      Provider Directory
    </Button>
  );
};
